export default class CssUtils {
  /**
   * CSSに変数を設定します。
   *
   * @param {String} variableName - 変数名
   * @param {String} variableValue - 変数値
   */
  static setCssVariable(variableName, variableValue) {
    document.documentElement.style.setProperty(`--${variableName}`, variableValue)
  }
}



// WEBPACK FOOTER //
// ./src/_helpers/css.util.js